<template>
  <div>
    <hero
      v-if="publishing"
      :publishing="publishing"
      :collected-corners="collectedCorners"
      :is-management-mode="isManagementMode"
      @refresh-publishing="handleRefreshPublishing"
      @handleToggleCollectPublishing="handleToggleCollectPublishing"
    />
    <!---- This is now simplly a dynamic publishing website page -->
    <template v-if="false">
      <block-resources
        v-if="resources && resources.length > 0"
        :resources="resources"
        @resource-clicked="handleResourceReveal"
      />
      <base-resource-bottom-sheet
        ref="base"
        :is-management-mode="isManagementMode"
        :publishing="publishing"
        :resource="selectedResource"
        @refresh-publishing="handleRefreshPublishing"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Hero from "../hero";
import BlockResources from "../blockResources";
import BaseResourceBottomSheet from "@/components/blockResources/baseResourceBottomSheet";

//import Ads from "vue-google-adsense";
//Vue.use(Ads.InArticleAdsense);
export default {
  name: "CornerDisplay",
  components: {
    Hero,
    BlockResources,
    BaseResourceBottomSheet
  },
  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    isManagementMode: {
      type: Boolean,
      default: false
    },
    publishing: {
      type: Object,
      required: false,
      default: () => {}
    },
    cornerListing: {
      type: Object,
      required: false,
      default: () => {}
    },
    cornerTitle: {
      type: String,
      required: false,
      default: null
    },
    resourcePath: {
      type: String,
      required: false,
      default: null
    },
    resourceItemPath: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      selectedResource: {},
      collectedCorners: []
    };
  },
  watch: {
    publishings(newVal, oldVal) {
      console.log(`Publishings Old: ${oldVal}`);
      console.log(`New: ${newVal}`);
      this.$forceUpdate();
    }
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    }),
    resources() {
      return this.publishing
        ? this.publishing
          ? this.publishing.tools
          : null
        : [];
    }
  },
  methods: {
    handleRefreshPublishing() {
      console.log("refreshing publishing corner Display");
      this.$emit("refresh-publishing");
    },
    handleResourceOnLoad(resourcePath) {
      //get valid resource
      const theResource = this.resources.filter(aResource => {
        return aResource.name.toLowerCase() === resourcePath.toLowerCase();
      })[0];

      if (theResource) {
        console.log(`Opening ${theResource.text}`);
        this.handleResourceReveal(theResource);
      } else {
        console.log("No resource");
      }
    },
    handleResourceReveal(resource) {
      this.selectedResource = resource;
      this.$refs.base.open();
    },
    handleResourceConceal() {
      this.selectedResource = {};
      this.$refs.base.hideResource();
    },
    handleOpen() {
      this.$refs.base.open();
    },
    getCollectedCornerPublishings() {
      if (this.user) {
        this.$store
          .dispatch("user/getCollectedCornerPublishings", this.user.uid)
          .then(corners => {
            this.collectedCorners = corners;
          });
      }
    },
    handleToggleCollectPublishing(data) {
      if (!this.user) {
        //this.$bvModal.show("loginModal");
        this.$route(`/signin?redirect=${this.cornerTitle}`);
      } else {
        if (data.collect) {
          this.$store
            .dispatch("user/collectCornerPublishing", this.corner.doc)
            .then(() => {
              this.getCollectedCornerPublishings();
              console.log("Collected");
            });
        } else {
          this.$store
            .dispatch("user/uncollectCornerPublishing", this.corner.doc)
            .then(() => {
              this.getCollectedCornerPublishings();
              console.log("unCollected");
            });
        }
      }
    }
  },
  mounted() {
    if (this.resourcePath) {
      this.handleResourceOnLoad(this.resourcePath);
    }
  }
};
</script>

<style lang="scss" scoped>
.corner {
  .horizontal-line {
    border-top: 1px solid #ddd;
  }
  .author-wrapper {
    position: relative;
    z-index: 9;
    .other-way {
      background: #ffffff;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      padding: 20px;
      position: fixed;
      top: 145px;
      right: 96px;
      .txt {
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        letter-spacing: 0.03em;
        color: #8d99a0;
      }
      .acts {
        margin-top: 16px;
        display: flex;
        .ico {
          cursor: pointer;
          margin-right: 24px;
          &:hover {
            transform: scale(1.07);
          }
        }
      }
    }
    .author-card {
      position: fixed;
      left: 100px;
      top: 50%;
      transform: translateY(-50%);
      width: 196px;
      z-index: 4;
      .author {
        .profile {
          cursor: pointer;
          display: grid;
          grid-template-columns: 36px 1fr;
          grid-column-gap: 11px;
          align-items: center;
          margin-bottom: 22px;
          img {
            height: 36px;
            width: 36px;
            border-radius: 50%;
            object-fit: cover;
          }
          .name {
            font-style: normal;
            font-weight: 600;
            font-size: 20px;
            line-height: 26px;
            color: #474d52;
            margin-bottom: 0px;
          }
          .email {
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            letter-spacing: 0.03em;
            text-decoration-line: underline;
            color: #8d99a0;
          }
        }
        .btn-follow {
          border: 1px solid #474d52;
          box-sizing: border-box;
          border-radius: 4px;
          width: 70px;
          height: 28px;
          padding: 0px;
          font-weight: normal;
          font-size: 12px;
          line-height: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #474d52;
          background-color: #fff;
          transition: 0.2s ease;
          margin-bottom: 24px;
          &:focus {
            box-shadow: none !important;
          }
          &:hover {
            background-color: #474d52;
            color: #fff;
            &:after,
            &:before {
              content: none;
            }
          }
        }
        .followed {
          width: 76px;
          color: #fff;
          background: #474d52;
        }
      }
      .stats {
        margin-top: 4px;

        .handshakes {
          height: 28px;
          margin-top: 20px;
          display: grid;
          grid-template-columns: 28px 1fr;
          grid-column-gap: 8px;
          .ico {
            &.clap {
              transform: translate(-20px, -33px);
            }
            //margin-right: 8px;
            user-select: none;

            cursor: pointer;
            position: relative;
            .animation- {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -66%) !important;
              svg {
                height: 60px;
                width: 60px;
              }
            }
          }
          .text {
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 19px;
            color: #8d99a0;
            user-select: none;
          }
        }
      }
      .author-details {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #474d52;
      }
    }
  }
  .wrapper {
    max-width: 728px;
    margin: 0 auto;
    padding-top: 47px;
    @media (max-width: 767px) {
      padding: 0 15px;
    }
    .title {
      font-style: normal;
      font-weight: 600;
      font-size: 40px;
      line-height: 55px;
      color: #474d52;
      margin-bottom: 41px;
      @media (max-width: 767px) {
        font-size: 26px;
        line-height: 34px;
      }
    }
    .content {
      padding-top: 47px;
      font-size: 20px;
      color: #19191a;
      p li {
        font-style: normal;
        font-weight: normal;
        line-height: 28px;
        letter-spacing: 0.03em;
        margin: 0;
      }
    }
    .tags {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      grid-gap: 8px;
      margin-top: 49px;
      margin-bottom: 22px;
      .tag {
        height: 42px;
        background: #ffffff;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
        border-radius: 48px;
        padding: 10px 16px;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #474d52;
        cursor: pointer;
        &:hover {
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
        }
      }
    }
  }
  .recommended {
    margin-top: 99px;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 27px;
    color: #474d52;
    margin-bottom: 24px;
  }
  .guide-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    grid-column-gap: 32px;
    &.recommended-cards {
      margin-bottom: 66px;
    }
  }
  .recomended-tools {
    margin-top: 66px;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 27px;
    color: #474d52;
    margin-bottom: 24px;
  }
  .tool {
    padding: 18px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    cursor: pointer;
    .first {
      display: grid;
      grid-template-columns: 32px 1fr;
      grid-column-gap: 8px;
      align-items: center;
      margin-bottom: 8px;
      img {
        height: 32px;
        width: 32px;
        object-fit: cover;
      }
      h3 {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #474d52;
        margin: 0;
      }
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        color: #474d52;
      }
    }
  }
}
.show-read-more .more-text {
  display: none;
}
.btn1 {
  border: none;
  color: black;
  background: transparent;
  font-weight: 600;
}
.card {
  background-color: #ffc727;
  border-radius: 10px;
  padding: 10px;
  display: block;
  cursor: pointer;
}
.card:hover {
  background-color: #222222;
  color: #ffc727;
  padding: 10px;
  fill: #ffc727;
  transform: scale(1.05);
}
.ico-bookmark {
  margin-right: 8px;
  cursor: pointer;
  &:hover {
    transform: scale(1.07);
  }
}
.ico-share {
  cursor: pointer;
  position: relative;
  svg {
    &:hover {
      transform: scale(1.07);
    }
  }
  &:active {
    transform: none;
  }
  .share-popup {
    position: absolute;
    width: 150px;
    height: 45px;
    padding: 10px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    top: 100%;
    left: 80%;
    z-index: 3;
    &:hover {
      transform: none;
    }
  }
}
</style>
